import { render, staticRenderFns } from "./myplayers.vue?vue&type=template&id=fcc70cbc&scoped=true"
import script from "./myplayers.vue?vue&type=script&lang=js"
export * from "./myplayers.vue?vue&type=script&lang=js"
import style0 from "./myplayers.vue?vue&type=style&index=0&id=fcc70cbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcc70cbc",
  null
  
)

export default component.exports